import { render } from "./choose-period.vue?vue&type=template&id=0e25950c&scoped=true&ts=true"
import script from "./choose-period.vue?vue&type=script&lang=ts"
export * from "./choose-period.vue?vue&type=script&lang=ts"

import "./choose-period.vue?vue&type=style&index=0&id=0e25950c&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e25950c"]])

export default __exports__